import { useContextGenerator } from '@lessonup/typescript-core/ui';
import React from 'react';
// eslint-disable-next-line import/no-cycle -- auto-generated TECH-258
import { AppServices } from '../../services/AppServices';

type Context = AppServices | undefined;

export const AppServicesContext = React.createContext<Context>(undefined);

interface Props {
  services: AppServices;
  children?: React.ReactNode;
}

export class AppServicesProvider extends React.PureComponent<Props> {
  public render() {
    return <AppServicesContext.Provider value={this.props.services}>{this.props.children}</AppServicesContext.Provider>;
  }
}

// eslint-disable-next-line react-hooks/rules-of-hooks -- auto-generated TECH-258
export const useAppServices: () => AppServices = useContextGenerator(AppServicesContext, 'AppServicesContext');

interface ConsumerProps {
  render: (services: AppServices) => React.ReactNode;
}

export class AppServicesConsumer extends React.PureComponent<ConsumerProps> {
  public render() {
    return (
      <AppServicesContext.Consumer>
        {(services) => {
          if (services === undefined) {
            throw new Error('AppServicesContext must be used within a Provider');
          }
          return this.props.render(services);
        }}
      </AppServicesContext.Consumer>
    );
  }
}
